import CreditAndBackgroundCheckComponent from 'shared/components/CreditAndBackgroundCheck'

const CreditAndBackgroundCheck = (props) => (
  <CreditAndBackgroundCheckComponent {...props} />
)

export default CreditAndBackgroundCheck
